import { render, staticRenderFns } from "./communityManagement.vue?vue&type=template&id=3614b87f&"
import script from "./communityManagement.vue?vue&type=script&lang=js&"
export * from "./communityManagement.vue?vue&type=script&lang=js&"
import style0 from "./communityManagement.vue?vue&type=style&index=0&id=3614b87f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports